module.exports = __webpack_public_path__ + "img/img4-2.7c716af5.png";